import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <div className="logo-icon">
              <div className="logo-shape logo-shape-1"></div>
              <div className="logo-shape logo-shape-2"></div>
              <div className="logo-cable">📡</div>
            </div>
            <div className="logo-text-wrapper">
              <span className="logo-text">CABLEBIZ</span>
              <span className="logo-tagline">CABLE & ISP COLLECTION APP</span>
            </div>
          </Link>

          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <Link 
              to="/" 
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className={`nav-link ${isActive('/about') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              About US
            </Link>
            <div className="nav-dropdown">
              <Link 
                to="/services" 
                className={`nav-link ${isActive('/services') ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Cable TV
              </Link>
            </div>
            <Link 
              to="/plans" 
              className={`nav-link ${isActive('/plans') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Plans
            </Link>
            <Link 
              to="/contact" 
              className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Contact Us
            </Link>
            <div className="nav-actions">
              <a 
                href="https://admin.cablebiz.in/" 
                className="btn btn-outline btn-sm"
                onClick={() => setIsMenuOpen(false)}
                target="_blank"
                rel="noopener noreferrer"
              >
                LOGIN
              </a>
              <a 
                href="https://admin.cablebiz.in/login/newregistration" 
                className="btn btn-primary btn-sm"
                onClick={() => setIsMenuOpen(false)}
                target="_blank"
                rel="noopener noreferrer"
              >
                REGISTER NOW
              </a>
            </div>
          </nav>

          <button 
            className="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;

